// Shared "needs my approval" matching, used by both the approvals list page and
// the sidebar badge so they apply the exact same rule.
import type { ApprovalRequest } from './api';

/** Lowercased ref + its short name (last path segment), for tolerant matching. */
export function identityKeys(ref: string): string[] {
  const lower = ref.toLowerCase();
  const short = lower.includes('/')
    ? lower.slice(lower.lastIndexOf('/') + 1)
    : lower;
  return [lower, short];
}

/** Build the set of identity keys for the current user's ownership refs. */
export function toMyKeys(
  ownershipEntityRefs: readonly string[] | undefined,
): Set<string> {
  return new Set((ownershipEntityRefs ?? []).flatMap(identityKeys));
}

/**
 * Whether any of the request's approvers (groups or users) matches the current
 * user's identity keys — i.e. the request needs the current user's approval.
 */
export function needsMyApproval(
  req: ApprovalRequest,
  myKeys: Set<string>,
): boolean {
  return [...req.approverGroups, ...req.approverUsers]
    .flatMap(identityKeys)
    .some(key => myKeys.has(key));
}
